/**
 * @flow
 * @relayHash 7b7a49843ebebfdd8656db72daa622e3
 */

/* eslint-disable */

"use strict";

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateUserMessagingTokenMutationVariables = {|
  token: string
|};
export type UpdateUserMessagingTokenMutationResponse = {|
  +updateUserMessagingToken: ?{|
    +ok: ?boolean
  |}
|};
export type UpdateUserMessagingTokenMutation = {|
  variables: UpdateUserMessagingTokenMutationVariables,
  response: UpdateUserMessagingTokenMutationResponse,
|};
*/

/*
mutation UpdateUserMessagingTokenMutation(
  $token: String!
) {
  updateUserMessagingToken(token: $token) {
    ok
  }
}
*/

const node /*: ConcreteRequest*/ = (function () {
  var v0 = [
      {
        kind: "LocalArgument",
        name: "token",
        type: "String!",
        defaultValue: null,
      },
    ],
    v1 = [
      {
        kind: "LinkedField",
        alias: null,
        name: "updateUserMessagingToken",
        storageKey: null,
        args: [
          {
            kind: "Variable",
            name: "token",
            variableName: "token",
            type: "String",
          },
        ],
        concreteType: "UpdateUserMessagingToken",
        plural: false,
        selections: [
          {
            kind: "ScalarField",
            alias: null,
            name: "ok",
            args: null,
            storageKey: null,
          },
        ],
      },
    ];
  return {
    kind: "Request",
    operationKind: "mutation",
    name: "UpdateUserMessagingTokenMutation",
    id: null,
    text:
      "mutation UpdateUserMessagingTokenMutation(\n  $token: String!\n) {\n  updateUserMessagingToken(token: $token) {\n    ok\n  }\n}\n",
    metadata: {},
    fragment: {
      kind: "Fragment",
      name: "UpdateUserMessagingTokenMutation",
      type: "Mutations",
      metadata: null,
      argumentDefinitions: v0,
      selections: v1,
    },
    operation: {
      kind: "Operation",
      name: "UpdateUserMessagingTokenMutation",
      argumentDefinitions: v0,
      selections: v1,
    },
  };
})();
// prettier-ignore
(node/*: any*/).hash = '0396e508a6d512de33702c1f08e2bee1';
module.exports = node;



// WEBPACK FOOTER //
// ./src/mutations/users/__generated__/UpdateUserMessagingTokenMutation.graphql.js